<template>
  <a-modal :visible="visible" title="公司内部帮忙找人" @ok="handleOk" @change="change">
    <a-form :labelCol="{ span: 6 }" :wrapperCol="{ span: 14 }">
      <a-form-item :labelCol="{ span: 24 }" :wrapperCol="{ span: 24 }" label="找人需求及理由简单描述(文字上限100字)">
        <a-textarea :max-length="100" :auto-size="{ minRows: 2, maxRows: 6 }" v-model="formData.reason"></a-textarea>
      </a-form-item>
      <a-form-item label="找人需求优先级">
        <a-radio-group v-model="formData.priority">
          <a-radio-button v-for="item in priorityOptions" :key="item.value" :value="item.value">
            {{ item.label }}
          </a-radio-button>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="找人需求紧迫度">
        <a-radio-group v-model="formData.urgency">
          <a-radio-button v-for="item in urgencyOptions" :key="item.value" :value="item.value">
            {{ item.label }}
          </a-radio-button>
        </a-radio-group>
      </a-form-item>

      <a-form-item label="让TA帮忙找" style="margin-bottom: 0">
        <a-radio-group v-model="formData.relatedType" @change="onChangeRelatedType">
          <a-radio v-for="item in relatedTypeOptions" :key="item.value" :value="item.value">
            {{ item.label }}
          </a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item v-if="formData.relatedType === 0" :wrapperCol="{ md: { span: 18, offset: 6 } }">
        <div class="tip"><a>全员表示公司内所有的飞书项目</a></div>
      </a-form-item>
      <a-form-item v-if="formData.relatedType === 1" :wrapperCol="{ md: { span: 18, offset: 6 } }">
        <div class="tip"><a>出于对公司组织架构的保护，请选择同学所在的部门。(可多选)</a></div>

        <select-group @change="changeUserGroup"></select-group>
      </a-form-item>
      <a-form-item v-if="formData.relatedType === 2" :wrapperCol="{ md: { span: 18, offset: 6 } }">
        <div class="tip"><a>只代表选定的同学本人。（可多选）</a></div>
        <select-member :userlist="formData.relatedUser" @chose="choseUser" @delChosenUser="delUserList(index)"></select-member>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import selectMember from '@/components/project/selectMember';
import SelectGroup from './selectGroup';
import { createTask } from '@/api/humint';

export default {
  model: {
    prop: 'visible',
    event: 'change'
  },
  components: {
    selectMember,
    SelectGroup
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    let priorityOptions = [
      {
        label: '非常重要',
        value: 0
      },
      {
        label: '较高',
        value: 1
      },
      {
        label: '普通',
        value: 2
      }
    ];
    let urgencyOptions = [
      {
        label: '非常紧急',
        value: 0
      },
      {
        label: '紧急',
        value: 1
      },
      {
        label: '普通',
        value: 2
      }
    ];
    let relatedTypeOptions = [
      {
        label: '全员',
        value: 0
      },
      {
        label: '指定部门',
        value: 1
      },
      {
        label: '指定同学',
        value: 2
      }
    ];
    return {
      priorityOptions,
      urgencyOptions,
      relatedTypeOptions,
      userList: [],
      userGroupList: [],
      formData: {
        reason: undefined,
        priority: 2,
        urgency: 2,
        relatedType: 2,
        relatedUser: []
      }
    };
  },
  computed: {},
  watch: {
    visible() {
      if (!this.visible) {
        this.formDataInit();
      }
    }
  },
  methods: {
    formDataInit() {
      this.formData = {
        reason: undefined,
        priority: 2,
        urgency: 2,
        relatedType: 2,
        relatedUser: []
      };
    },
    onChangeRelatedType() {
      this.formData.relatedUser = [];
    },
    choseUser(list) {
      this.formData.relatedUser = list;
    },
    delUserList(index) {
      this.formData.relatedUser.splice(index, 1);
    },
    changeUserGroup(list) {
      this.formData.relatedUser = list;
    },
    change(value) {
      this.$emit('change', value);
    },
    handleOk() {
      console.log('sss');
      // check form

      if (!this.formData.reason) {
        this.$message.error('请填写找人需求及理由简单描述');
        return;
      }
      if (this.formData.relatedType === 1 && this.formData.relatedUser.length === 0) {
        this.$message.error('请选择成员在部门');
        return;
      }
      if (this.formData.relatedType === 2 && this.formData.relatedUser.length === 0) {
        this.$message.error('请选择成员');
        return;
      }
      createTask({
        ...this.formData,
        relatedUser: this.formData.relatedUser.map(item => item.id)
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('创建成功');
          this.$emit('change', false);
          return;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.tip {
  font-size: 14px;
  line-height: 1.2;
  margin-bottom: 5px;
}
</style>
